import type { PropsWithChildren } from 'react';

// Designer hasn't confirmed dark-mode strategy (see designer-questions.md).
// This component exists so consumers can wrap children today; will be filled
// in once the design system has a confirmed token set per theme.
export function ThemeProvider({ children }: PropsWithChildren) {
  return <>{children}</>;
}
